// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from 'E:/IdeaProjects/Creche/ParentZone/client/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": require('@/layouts/index.tsx').default,
    "routes": [
      {
        "path": "/",
        "exact": true,
        "component": require('@/pages/index.tsx').default,
        "routes": []
      },
      {
        "path": "/complete-submission",
        "exact": true,
        "component": require('@/pages/complete-submission/index.tsx').default,
        "routes": []
      },
      {
        "path": "/faceauthb",
        "exact": true,
        "component": require('@/pages/faceauthb/index.tsx').default,
        "routes": []
      },
      {
        "path": "/foster-apply-detail",
        "exact": true,
        "component": require('@/pages/foster-apply-detail/index.tsx').default,
        "routes": []
      },
      {
        "path": "/foster-apply-list",
        "exact": true,
        "component": require('@/pages/foster-apply-list/index.tsx').default,
        "routes": []
      },
      {
        "path": "/foster-complete-submission",
        "exact": true,
        "component": require('@/pages/foster-complete-submission/index.tsx').default,
        "routes": []
      },
      {
        "path": "/foster-detail",
        "exact": true,
        "component": require('@/pages/foster-detail/index.tsx').default,
        "routes": []
      },
      {
        "path": "/foster-service",
        "exact": true,
        "component": require('@/pages/foster-service/index.tsx').default,
        "routes": []
      },
      {
        "path": "/fosterappnote",
        "exact": true,
        "component": require('@/pages/fosterappnote/index.tsx').default,
        "routes": []
      },
      {
        "path": "/service-step",
        "exact": true,
        "component": require('@/pages/service-step/index.tsx').default,
        "routes": []
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
